var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a3 3 0 10.001 6 3 3 0 000-6",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 16a3 3 0 110-6 3 3 0 010 6m0-13C10.477 3 6 7.478 6 13c0 7 10 16 10 16s10-9 10-16c0-5.522-4.478-10-10-10",
    fill: props.color
  })));
}

export default SvgIconSpot;